import { ColumnIndex } from '../interfaces/ColumnRange';
import { Offset } from '../interfaces/LayoutInterval';

/**
 * Gets the column in which an offset appears.
 * @param offset The layout offset we're interested in.
 * @param columnLength The length of the columns in the current view.
 * @returns The index of the column in which the given offset appears.
 */
export function getColumn(offset: Offset, columnLength: number): ColumnIndex {
    return Math.floor(offset / columnLength);
}
